// import Vue from 'vue'
import axios from 'axios'
// import store from '@/store'
import qs from 'qs'
// import router from '@/router'
import {
  getCache,
  setCache,
  generateCacheKey,
  setAxiosInstance,
  DEFAULT_EXPIRE_TIME
} from './cache'

const instance = axios.create({
  baseURL: '',  // 空，通过 Apache 代理访问
  timeout: 2500,
  withCredentials: false,  // 禁用自动发送 cookie
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
})

// 设置 axios 实例引用（供缓存管理器静默刷新使用）
setAxiosInstance(instance)

// 包装请求方法，支持缓存短路返回
const request = function(config) {
  // 处理参数序列化
  const configCopy = { ...config }
  
  // 确保 headers 存在
  if (!configCopy.headers) {
    configCopy.headers = {}
  }
  
  // 如果没有设置 Content-Type，使用默认值
  if (!configCopy.headers['Content-Type']) {
    configCopy.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  
  if (
    configCopy.data &&
    configCopy.headers['Content-Type'] ===
      'application/x-www-form-urlencoded;charset=UTF-8'
  ) {
    configCopy.data = qs.stringify(configCopy.data)
  }

  // 缓存逻辑：仅对 GET 请求或显式开启缓存的请求生效
  const method = (configCopy.method || 'get').toLowerCase()
  const shouldCache = method === 'get' || configCopy.enableCache

  // 跳过缓存的情况：显式跳过、刷新请求、POST 默认不缓存
  if (!configCopy.skipCache && !configCopy._isRefresh && shouldCache) {
    // 生成缓存 key
    const cacheKey = generateCacheKey(configCopy)

    // 检查缓存
    const cachedData = getCache(cacheKey)
    if (cachedData) {
      // 缓存命中，直接返回缓存数据，不发送实际请求
      return Promise.resolve({
        data: cachedData.data,
        status: 200,
        statusText: 'OK (from cache)',
        headers: {},
        config: configCopy,
        _fromCache: true
      })
    }

    // 保存 cacheKey 供响应拦截器使用
    configCopy._cacheKey = cacheKey
  }

  // 发送实际请求
  return instance(configCopy)
}

// 为 request 方法添加拦截器（用于缓存响应数据）
instance.interceptors.response.use(
  (response) => {
    // 缓存响应数据
    const config = response.config
    const cacheKey = config._cacheKey

    if (cacheKey && response.status === 200) {
      const expireTime = config.cacheTime || DEFAULT_EXPIRE_TIME
      setCache(cacheKey, response.data, expireTime, config)
    }

    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default request
